// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Exit';

type ExitProps = {
  title?: string;
  className?: string;
};

export function ExitThin({ title = TITLE, className }: ExitProps) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.45 3.45L20.55 2.55L12 11.1L3.45 2.55L2.55 3.45L11.1 12L2.55 20.55L3.45 21.45L12 12.9L20.55 21.45L21.45 20.55L12.9 12L21.45 3.45Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function Exit({ title = TITLE, className }: ExitProps) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <path
        d="M12 10.1651L3.83495 2L2 3.83495L10.1651 12L2 20.1651L3.83495 22L12 13.8349L20.1651 22L22 20.1651L13.8349 12L22 3.83495L20.1651 2L12 10.1651Z"
        fill="currentColor"
      />
    </svg>
  );
}
